var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRettangleModalPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 31,
    viewBox: "0 0 175 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_410",
    "data-name": "Rettangolo 410",
    width: 175,
    height: 31,
    rx: 15.5,
    fill: "#c9313d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRettangleModalPro);
export default __webpack_public_path__ + "static/media/rettangle-modal-pro.7d076dd6b7bcf07b55c60ea0c41b709f.svg";
export { ForwardRef as ReactComponent };